/**
 * @generated SignedSource<<e75293f715404f15a4e63f4d57507a1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type usageControlsMutationsDeleteMutation$variables = {
  toolUsageRuleID: number;
};
export type usageControlsMutationsDeleteMutation$data = {
  readonly deleteToolUsageRule: boolean;
};
export type usageControlsMutationsDeleteMutation = {
  response: usageControlsMutationsDeleteMutation$data;
  variables: usageControlsMutationsDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "toolUsageRuleID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "toolUsageRuleID",
        "variableName": "toolUsageRuleID"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteToolUsageRule",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usageControlsMutationsDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usageControlsMutationsDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f9cf728897a0cccaa638b35e0e8662c0",
    "id": null,
    "metadata": {},
    "name": "usageControlsMutationsDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation usageControlsMutationsDeleteMutation(\n  $toolUsageRuleID: Long!\n) {\n  deleteToolUsageRule(toolUsageRuleID: $toolUsageRuleID)\n}\n"
  }
};
})();

(node as any).hash = "48c8e75e22400fd7539d0f7fdd6bbb8a";

export default node;
